var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatControlStatementReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_47607dea7ae0cd4ca0bb5b9d71bde513fc9817c175a2887236a83cb910fe36be",
    x1: 55.094,
    y1: 101.443,
    x2: 72.784,
    y2: 101.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_47607dea7ae0cd4ca0bb5b9d71bde513fc9817c175a2887236a83cb910fe36be",
    x1: 48.837,
    y1: 77.179,
    x2: 79.286,
    y2: 77.179,
    xlinkHref: "#SVGID_0_47607dea7ae0cd4ca0bb5b9d71bde513fc9817c175a2887236a83cb910fe36be"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_47607dea7ae0cd4ca0bb5b9d71bde513fc9817c175a2887236a83cb910fe36be",
    x1: 79.146,
    y1: 131.077,
    x2: 104.895,
    y2: 131.077,
    xlinkHref: "#SVGID_0_47607dea7ae0cd4ca0bb5b9d71bde513fc9817c175a2887236a83cb910fe36be"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M78.051 80.819h71.119l-20.581-12.533-20.581-12.532-20.581 12.532-9.267 5.644M88.715 81.28v24.633M137.854 81.28v36.912H127.19V81.28M113.39 118.192h34.772"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M66.801 133.711c-5.653 0-10.667-4.018-10.45-10.676l.208-46.144c0-4.151 3.567-7.718 7.718-7.718s7.214 4.019 7.214 8.171l.043 24.394",
    stroke: "url(#SVGID_0_47607dea7ae0cd4ca0bb5b9d71bde513fc9817c175a2887236a83cb910fe36be)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M50.087 109.387l.022-52.436c0-7.16 6.804-12.963 13.963-12.963s13.963 5.804 13.963 12.963v53.422",
    stroke: "url(#SVGID_1_47607dea7ae0cd4ca0bb5b9d71bde513fc9817c175a2887236a83cb910fe36be)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 92.074,
    cy: 130.379,
    r: 24.457
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_2_47607dea7ae0cd4ca0bb5b9d71bde513fc9817c175a2887236a83cb910fe36be)",
    d: "M80.396 130.849l8.205 9.117 15.044-17.778"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatControlStatementReport);
export default __webpack_public_path__ + "static/media/vatControlStatementReport.a47dae770fcc3871cacb8fa6a364aad8.svg";
export { ForwardRef as ReactComponent };